import { cn } from '@rocco/utils/cn';
import { useIsHomePage } from '../use-is-home-page';

/**
 * Outline "Coming Soon" pill shown on pre-launch sections (US Products +
 * Magazine). Sized on the 1920 frame in vw so it scales with the section.
 */
export const ComingSoonPill = ({ className }: { className?: string }) => {
    const isHomePage = useIsHomePage();
    return (
        <span
            className={cn(
                'inline-flex w-fit items-center justify-center rounded-[var(--radius-btn-m)] border border-black font-sans font-normal tracking-[-0.03em] whitespace-nowrap text-black max-md:px-7 max-md:py-3 max-md:text-sm md:h-[3.125vw] md:px-[1.436vw]',
                isHomePage ? 'md:text-[0.8865vw]' : 'md:text-[1.182vw]',
                className,
            )}
        >
            Coming Soon - Fall 2026
        </span>
    );
};
